<template>
  <div class="m-head">
    <div class="line flex-between">
      <img src="../../assets/img/mobile/logo.svg" class="logo" />
      <m-nav></m-nav>
    </div>
    <m-search v-if="!isContact"></m-search>
  </div>
</template>

<script>
import mNav from "../../components/mobile/Nav";
import mSearch from "../../components/mobile/Search";
export default {
  components: {
    mNav,
    mSearch
  },
  computed: {
    isContact() {
      return this.$route.path === "/contact";
    }
  }
};
</script>

<style lang="scss" scoped>
.m-head {
  height: 113px;
  background: $white;
  .line {
    width: 342px;
    margin: 0 auto;
    padding-top: 14px;
  }
}
</style>